export const MORTGAGE_PARAPLANNERS = [
  {
    name: "Siddharth Nakul",
    email: "siddharth.nakul@rosemountfs.co.uk",
  },
  {
    name: "Chloe Donovan",
    email: "chloe.donovan@rosemountfs.co.uk",
  },
];

export const FINANCIAL_PLANNING_PARAPLANNERS = [
  {
    name: "Luke Onuoha",
    email: "luke.onuoha@rosemountfs.co.uk",
  },
  {
    name: "Hamza Nazir",
    email: "hamza.nazir@rosemountfs.co.uk",
  },
  {
    name: "Jacko Lam",
    email: "jacko.lam@rosemountfs.co.uk",
  },
  {
    name: "George Taylor",
    email: "george.taylor@rosemountfs.co.uk",
  },
  {
    name: "Elliot Burley",
    email: "elliot.burley@rosemountfs.co.uk",
  },
  {
    name: "Davin Thomas",
    email: "davin.thomas@rosemountfs.co.uk",
  },
];

export const getParaplannerTypeByEmail = (email = "") => {
  const normalisedEmail = String(email).trim().toLowerCase();

  const isMortgageParaplanner = MORTGAGE_PARAPLANNERS.some(
    (user) => user.email.toLowerCase() === normalisedEmail,
  );

  if (isMortgageParaplanner) {
    return "mortgage_protection";
  }

  const isFinancialPlanningParaplanner = FINANCIAL_PLANNING_PARAPLANNERS.some(
    (user) => user.email.toLowerCase() === normalisedEmail,
  );

  if (isFinancialPlanningParaplanner) {
    return "financial_planning";
  }

  return "mortgage_protection";
};

export const getParaplannerNameByEmail = (email = "") => {
  const normalisedEmail = String(email).trim().toLowerCase();

  const allParaplanners = [
    ...MORTGAGE_PARAPLANNERS,
    ...FINANCIAL_PLANNING_PARAPLANNERS,
  ];

  const found = allParaplanners.find(
    (user) => user.email.toLowerCase() === normalisedEmail,
  );

  return found?.name || "";
};
